(() => {
  const ELEMENT_NAME = 'clara-gift-progress';

  if (customElements.get(ELEMENT_NAME)) {
    return;
  }

  class ClaraGiftProgress extends HTMLElement {
    constructor() {
      super();

      this.requestId = 0;
      this.handleCartChange = this.handleCartChange.bind(this);
      this.handleCartRefresh = this.handleCartRefresh.bind(this);
    }

    connectedCallback() {
      this.giftVariantId = String(this.dataset.giftVariant || '');
      this.threshold = Number(this.dataset.threshold) || 2;

      this.messageElement = this.querySelector('[data-gift-message]');
      this.statusElement = this.querySelector('[data-gift-status]');
      this.progressElement = this.querySelector('[data-gift-progress]');
      this.fillElement = this.querySelector('[data-gift-fill]');

      document.addEventListener('cart:change', this.handleCartChange);

      document.documentElement.addEventListener(
        'cart:refresh',
        this.handleCartRefresh
      );

      this.fetchCart();
    }

    disconnectedCallback() {
      document.removeEventListener(
        'cart:change',
        this.handleCartChange
      );

      document.documentElement.removeEventListener(
        'cart:refresh',
        this.handleCartRefresh
      );
    }

    handleCartChange(event) {
      const updatedCart = event.detail?.cart;

      if (updatedCart?.items) {
        this.render(updatedCart);
        return;
      }

      this.fetchCart();
    }

    handleCartRefresh() {
      window.requestAnimationFrame(() => {
        this.fetchCart();
      });
    }

    async fetchCart() {
      const currentRequest = ++this.requestId;
      const shopRoot = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${shopRoot}cart.js`, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Falha ao consultar o carrinho: ${response.status}`);
        }

        const cart = await response.json();

        if (currentRequest === this.requestId) {
          this.render(cart);
        }
      } catch (error) {
        console.error('[Clara Gift Progress]', error);
      }
    }

    getEligibleQuantity(cart) {
      return cart.items.reduce((total, item) => {
        const isGift =
          String(item.variant_id) === this.giftVariantId;

        if (isGift) {
          return total;
        }

        return total + Number(item.quantity || 0);
      }, 0);
    }

    render(cart) {
      const eligibleQuantity = this.getEligibleQuantity(cart);

      if (eligibleQuantity === 0) {
        this.hidden = true;
        return;
      }

      this.hidden = false;

      const hasEarnedGift =
        eligibleQuantity >= this.threshold;

      const completedQuantity = Math.min(
        eligibleQuantity,
        this.threshold
      );

      const percentage = Math.round(
        (completedQuantity / this.threshold) * 100
      );

      this.dataset.state = hasEarnedGift
        ? 'earned'
        : 'pending';

      this.fillElement.style.width = `${percentage}%`;

      this.progressElement.setAttribute(
        'aria-valuenow',
        String(percentage)
      );

      if (hasEarnedGift) {
        this.messageElement.innerHTML =
          '🎉 Parabéns! Você garantiu seus <strong>óculos grátis</strong>!';

        this.statusElement.textContent =
          '✓ O brinde será adicionado automaticamente ao carrinho';

        return;
      }

      const remaining = this.threshold - eligibleQuantity;
      const pieceLabel = remaining === 1 ? 'peça' : 'peças';

      this.messageElement.innerHTML =
        `🎁 Adicione mais <strong>${remaining} ${pieceLabel}</strong> ` +
        'e ganhe um <strong>óculos de graça</strong>!';

      this.statusElement.textContent =
        `${eligibleQuantity}/${this.threshold} peças adicionadas`;
    }
  }

  customElements.define(ELEMENT_NAME, ClaraGiftProgress);
})();